import { z } from 'zod'

const participant = z.object({
  id: z.string().optional(),
  name: z.string().min(1, {
    message: 'Jméno nesmí být prázdné',
  }),
  email: z.union([
    z.string().email(),
    z.literal(''),
  ]).nullable().optional(),
  phone: z.string().regex(/^(\+?[0-9 ]+)?$/, {
    message: 'phone.errors.invalid',
  }).nullable().optional(),
  address: z
    .object({
      address: z.string().optional(),
      addressLine2: z.string().optional(),
      city: z.string().optional(),
      state: z.string().optional(),
      zip: z.string().optional(),
      country: z.string().optional().nullable(),
    })
    .optional(),
  businessId: z
    .string()
    .regex(/[0-9]*/gi)
    .optional()
    .nullable(),
  taxId: z.string().optional().nullable(),
  accountNumber: z.string().optional().nullable(),
  iban: z.string().optional().nullable(),
})

const item = z.object({
  amount: z.coerce
    .number({ invalid_type_error: 'Množství musí být číslo' })
    .positive({ message: 'Množství musí být větší než 0' })
    .nullable(),
  unit: z.string({
    coerce: true,
  }),
  description: z
    .string({
      invalid_type_error: 'Vyplňte popis položky',
      required_error: 'Vyplňte popis položky',
    })
    .min(1, {
      message: 'Vyplňte popis položky',
    })
    .max(2000, {
      message: 'Popis může mít nejvýš 2000 znaků',
    })
    .nullable(),
  taxRate: z.coerce.number().nonnegative().optional().nullable(),
  skuId: z.string().optional().nullable(),
  // Not editable, but the backend replaces the items, so the form must send them back
  lineExtras: z.array(z.record(z.unknown())).optional().nullable(),
  unitPrice: z
    .coerce
    .number({
      invalid_type_error: 'Cena musí být číslo',
      required_error: 'Vyplňte cenu',
    })
    .multipleOf(0.01, {
      message: 'documentForm.items.errors.unitPrice.multipleOf',
    })
    // .transform((val) => val.toFixed(2))
    // .positive({
    //   message: 'Cena musí být kladná',
    // })
    .nullable(),
})

export const DocumentFormSchema = z.object({
  supplier: participant.optional(),
  customer: participant,
  beneficiary: participant.optional().nullable(),
  description: z.string().optional().nullable(),
  settings: z.object({
    issueDate: z.string().optional(),
    dueDate: z.string().optional(),
    taxDate: z.string().optional(),
    currency: z.string(),
    paymentMethod: z.enum(['bankTransfer', 'cash', 'card', 'cod', 'other']).optional(),
    variableSymbol: z.string().nullable().optional(),
    bankAccountId: z.string().optional().nullable(),

    expenseType: z.enum(['invoice', 'receipt', 'other']).optional(),
    receivedDate: z.string().optional(),
    externalId: z.string().optional(),
    vatDeductible: z.boolean().optional(),
    vatDeductionProportionPercent: z.number().min(0).max(100).multipleOf(1).optional(),
  }),
  items: z.array(item),
})

export const OrderFormSchema = DocumentFormSchema.extend({
  type: z.literal('order'),
})

export const InvoiceFormSchema = DocumentFormSchema.extend({
  type: z.literal('invoice'),
  settings: DocumentFormSchema.shape.settings.extend({
    taxDate: z.string().optional(),
  }),
})

export const ExpenseFormSchema = InvoiceFormSchema.extend({
  type: z.literal('expense'),
  settings: DocumentFormSchema.shape.settings.extend({
    expenseType: z.enum(['invoice', 'receipt', 'other']).optional(),
    receivedDate: z.string().optional(),
    externalId: z.string().optional(),
    vatDeductible: z.boolean(),
    vatDeductionProportionPercent: z.number().min(0).max(100).multipleOf(1).optional(),
  }),
})
